import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'services-versions',
  templateUrl: './services-versions.component.html',
  styleUrls: ['./services-versions.component.scss'],
})
export class ServicesVersionsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
